import { styled } from '../../../theme/styled';
import { Typography } from '../../typography';
import { AudioPlayerOwnerState } from '../model';

export const AudioPlayerDuration = styled(Typography, {
  name: 'AudioPlayer',
  slot: 'Duration',
})<{ ownerState: AudioPlayerOwnerState }>(({ theme, ownerState }) => {
  return {
    ...theme.typography['small text'],
    marginLeft: { normal: 15, small: 8 }[ownerState.size],
  };
});
